import { render } from "./StandsPanel.vue?vue&type=template&id=11556ccb&scoped=true"
import script from "./StandsPanel.vue?vue&type=script&lang=js"
export * from "./StandsPanel.vue?vue&type=script&lang=js"

import "./StandsPanel.vue?vue&type=style&index=0&id=11556ccb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11556ccb"]])

export default __exports__